import {wrapTable, wrapIframe} from '@shopify/theme-rte'
import $ from 'jquery'
const rteWrappers = function () {
  // Target tables to make them scrollable
  const tableSelectors = `.rte table`

  wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: `rte__table-wrapper rte-table-main-wrapper`,
  })

  // Target iframes to make them responsive
  const iframeSelectors =
    `.rte iframe[src*="youtube.com/embed"],` +
    `.rte iframe[src*="player.vimeo"]`

  wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: `rte__video-wrapper rte-video-wrapper`,
  })
}

export default rteWrappers
